import React, { Component } from "react";
import {
    connectCurrentRefinements,
    createClassNames
} from "react-instantsearch-dom";
import classNames from "classnames";
import PropTypes from "prop-types";

const itemPropTypes = PropTypes.arrayOf(
    PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.func.isRequired,
        items: (...args) => itemPropTypes(...args)
    })
);

const cx = createClassNames("CurrentRefinements");

class CurrentRefinements extends Component {
    static propTypes = {
        items: itemPropTypes.isRequired,
        canRefine: PropTypes.bool.isRequired,
        refine: PropTypes.func.isRequired
    };

    render() {
        const { items, canRefine, refine } = this.props;

        return (
            <div className={classNames(cx("", !canRefine && "-noRefinement"))}>
                <ul className={cx("list", !canRefine && "list--noRefinement")}>
                    {items.map(item => (
                        <li key={item.id} className={cx("item")}>
                            <span className={cx("label")}>
                                {item.label.replace(`${item.attribute}: `, "")}
                            </span>
                            {item.items ? (
                                item.items.map(nest => (
                                    <span
                                        key={nest.label}
                                        className={cx("category")}
                                    >
                                        <span className={cx("categoryLabel")}>
                                            {nest.label}
                                        </span>
                                        <button
                                            className={cx("delete")}
                                            onClick={() => refine(nest.value)}
                                        >
                                            x
                                        </button>
                                    </span>
                                ))
                            ) : (
                                <span className={cx("category")}>
                                    <button
                                        className={cx("delete")}
                                        onClick={() => refine(item.value)}
                                    >
                                        x
                                    </button>
                                </span>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default connectCurrentRefinements(CurrentRefinements);



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/CurrentRefinements.js